import React, { Component } from 'react';

import { normalize } from 'utils/stringFunctions';
import QualityItemComponent from './QualityItemComponent';
import { IQuality } from 'types/qualities';

interface State {
  expanded: boolean,
}

interface Props extends IQuality {
  filterString?: string,
}

export default class QualityItemContainer extends Component<Props, State> {
  static displayName = 'QualityItemContainer';

  state = {
    expanded: false,
  };

  toggleExpanded = () => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  };

  render() {
    const {
      availableAt,
      effectiveLevel,
      filterString,
      description,
      id,
      image,
      nameAndLevel,
      name,
      relationshipDescription,
    } = this.props;

    if (normalize(name).indexOf(normalize(filterString)) < 0) {
      return null;
    }

    const {
      expanded,
    } = this.state;

    const tooltipData = {
      ...this.props,
      level: effectiveLevel,
      secondaryDescription: availableAt,
    };

    return (
      <QualityItemComponent
        description={description}
        expanded={expanded}
        id={id}
        image={image}
        nameAndLevel={nameAndLevel}
        onToggleExpanded={this.toggleExpanded}
        name={name}
        relationshipDescription={relationshipDescription}
        tooltipData={tooltipData}
      />
    );
  }
}
